// Single source of truth for how this app identifies itself in transactional
// email. Change these and every branded email follows - nothing lives in the
// Supabase dashboard.
export const BRAND = {
  app_name: 'FieldOrtho',
  brand_dark: '#1a3468',
  brand_light: '#214185',
  app_url: 'https://fieldortho.netlify.app',
};
